<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-banner p-col-fixed txt-right txt-required">Author</label>
          <div class="p-col">
            <InputText id="name" class="p-inputtext p-col-width pac-target-input"
              placeholder="Author" v-model="obj_data.author"
               />
          </div>
        </div>
      </div>
      
      <div class="col-6">
        <div class="p-card-field div_check">
          <label class="indam-banner p-col-fixed txt-right">Stars</label>
          <div class="p-col checkbox" style="display: flex; gap: 10px; align-items: center;">
            <span v-for="n in 5" :key="n" style="display: flex; align-items: center;">
              <input
                type="radio"
                :id="'star-' + n"
                name="stars"
                :value="n"
                v-model="obj_data.stars"
              />
              <label :for="'star-' + n" style="margin-left: 2px; margin-top : 5px; font-size: 20px;">{{ n }} <span style="color: gold;">★</span></label>
            </span>
          </div>
        </div>
      </div>


      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-banner p-col-fixed txt-right txt-required">Comment</label>
          <div class="p-col">
            <textarea
              id="comment"
              class="p-inputtext p-col-width pac-target-input ml-0"
              style="min-height: 150px;"
              placeholder="Enter up to 255 characters"
              v-model="obj_data.comment"
              maxlength="255"
              @input="handleMaxCharacter($event, 255)"
            />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="p-card-field mt-2">
          <label class="indam-banner p-col-fixed txt-right txt-required">Avatar author</label>
          <div class="p-col">
            <div class="cus-text opacity-text-file mt-0">Accepted: Image (JPG, JPEG, PNG, GIF, SVG).
            </div>
            <input class="p-inputtext p-component" accept="image/*,video/mp4,video/quicktime" name="images[]"
              id="images_service" type="file" @change="onFileSelectFile" />
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="p-card-field">
          <label class="indam-banner p-col-fixed txt-right txt-required">Ordinal</label>
          <div class="p-col">
            <InputText id="ordinal" class="p-inputtext p-col-width pac-target-input"
              placeholder="ordinal" v-model="obj_data.ordinal"
              />
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
      <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
        Are you sure you want to delete?
        <template #footer>
          <Button label="Delete" @click="deleteData()" icon="pi pi-check"
            class="p-button-danger  btn-confirm-delete-dialog" />
          <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        </template>
      </Dialog>
    </div>
  </form>
</template>
<script>

export default {
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      key_type_id: 1,
      deleteId: null,
      showDeleteDialog: false,
      listDataType: [],
      obj_data: {},
      comFilename: 1,
      componentKey: 0,
      list_file: [],
      list_file_edit: [],
      list_id_file_delete: [],
      maxFileSize: 2097152 * 50,
      thumbnail: null
    }
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit)) {
        var list_file_edit = this.model?.list_file_edit
        for (let i = 0; i < list_file_edit.length; i++) {
          var item_file = list_file_edit[i]
          let fileUrl = item_file.url;
          let fileExtension = fileUrl.split('.').pop().toLowerCase();
          if (['mp4', 'mov', 'quicktime'].includes(fileExtension)) {
            fileUrl = item_file.obj_file.url_thumb
          }
          var obj = { id: item_file.id, 'name': '', 'file': '', 'objectURL': fileUrl,  type: 'old_edit' }
          this.list_file.push(obj)
        }
      }
      this.componentKey++;
    } else {
      this.obj_data = {
        active: true,
        stars: 5,
        ordinal: 1,
      };
      this.componentKey++;
    }
  },
  methods: {
    handleMaxCharacter(event, maxLength = 255) {
      let value = event
      if (value.length > maxLength) {
        value = value.slice(0, maxLength)
      }
      // this.obj_data.comment = value;
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = []
      for (let i = 0; i < this.listDataType.length; i++) {
        var item_data = this.listDataType[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataType = list_data;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${year}`;
    },
    async onFileSelectFile(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 50) {
        alert("You can only upload a maximum of 50 files at a time");
      } else {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'svg', 'mp4', 'mov', 'quicktime'];
        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop().toLowerCase();
          console.log('fileExtension', fileExtension)
          if (files[i].size > 300 * 1024 * 1024) {
            alert("File size cannot exceed 300MB.");
            event.target.value = null;
            return;
          }
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg, mp4, mov");
            event.target.value = null;
            return;
          }
        }
        if (this.list_file.length > 0) {
          this.onFileClear(this.list_file[0], 0);
        }
        let file = files[0];
        file.source = file;
        if (file.type.startsWith('video/')) {
          const videoElement = document.createElement('video');
          videoElement.src = URL.createObjectURL(file);
          await new Promise((resolve) => {
            videoElement.onloadedmetadata = async () => {
              this.thumbnail = await this.captureThumbnail(videoElement);
              resolve();
            };
          });
          file.objectURL = this.thumbnail
        } else {
          file.objectURL = window.URL.createObjectURL(file);
        }
        this.list_file.push(file);
        event.target.value = null;
      }

    },
    async captureThumbnail(videoElement) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        videoElement.currentTime = 1;
        videoElement.onseeked = () => {
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((blob) => {
            if (blob) {
              const dataURL = URL.createObjectURL(blob);
              resolve(dataURL);
            } else {
              reject(new Error('Failed to capture thumbnail'));
            }
          }, 'image/jpeg');
        };
        videoElement.onerror = (error) => {
          reject(new Error('Failed to seek video: ' + error.message));
        };
      });
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.author },
        { id: "stars", value: this.obj_data.stars, minValue: 0 },
        { id: "comment", value: this.obj_data.comment },
        { id: "ordinal", value: this.obj_data.ordinal, minValue: 0 }
      ];
      console.log('fieldsToValidate', fieldsToValidate);
      
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          console.log('field.value', field.value);
          
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else if (field.id === "comment" && field.value.length > 255) {
            inputElement.setCustomValidity("Name must not exceed 255 characters.");
            isFormInvalid = true;
          } else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let list_file = document.getElementById("list_file");
      if (this.list_file.length === 0) {
        list_file.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file.reportValidity();
        isFormInvalid = true;
      } else {
        list_file.setCustomValidity("");
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var params = { ...this.obj_data };
      params.list_file = this.list_file;
      params.list_file_edit = this.list_file_edit;
      params.list_id_file_delete = this.list_id_file_delete;
      console.log('paramsparamsparamsparams', params);
      
      
      this.$emit('save', params);
    },
    onFileClear(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item);
      }
      this.list_file.splice(index, 1);
    },
  },
}
</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.p-formgrid .fixed-bottom-toolbar .p-button#back .p-button-label {
  color: #000000 !important;
  font-weight: 500;
}

.p-formgrid .fixed-bottom-toolbar .main-style-button {
  background-color: #ffdf01 !important;
  font-weight: 500;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}

.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.indam-banner {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
</style>
